import { apiClient } from './client';
import {
  ProjectDetails, ProjectObjective, ProjectOutcome, ProjectOutput, ProjectIndicator,
  ProjectActivity, ProjectBeneficiaries, ProjectRisk, ProjectImplementation, ProjectMeal,
} from '../types/projects';

export const projectDetailsApi = {
  get: (projectId: number) => apiClient.get<{ data: ProjectDetails }>(`/api/projects/${projectId}/details`),
  update: (projectId: number, input: Partial<ProjectDetails>) => apiClient.put<{ data: ProjectDetails }>(`/api/projects/${projectId}/details`, input),
};

export const projectBeneficiariesWorkspaceApi = {
  get: (projectId: number) => apiClient.get<{ data: ProjectBeneficiaries }>(`/api/projects/${projectId}/beneficiaries`),
  update: (projectId: number, input: Partial<ProjectBeneficiaries>) => apiClient.put<{ data: ProjectBeneficiaries }>(`/api/projects/${projectId}/beneficiaries`, input),
};

export const projectImplementationApi = {
  get: (projectId: number) => apiClient.get<{ data: ProjectImplementation }>(`/api/projects/${projectId}/implementation`),
  update: (projectId: number, input: Partial<ProjectImplementation>) => apiClient.put<{ data: ProjectImplementation }>(`/api/projects/${projectId}/implementation`, input),
};

export const projectMealApi = {
  get: (projectId: number) => apiClient.get<{ data: ProjectMeal }>(`/api/projects/${projectId}/meal`),
  update: (projectId: number, input: Partial<ProjectMeal>) => apiClient.put<{ data: ProjectMeal }>(`/api/projects/${projectId}/meal`, input),
};

export const projectObjectivesApi = {
  list: (projectId: number) => apiClient.get<{ data: ProjectObjective[] }>(`/api/projects/${projectId}/objectives`),
  create: (projectId: number, input: { objectiveNumber: number; title: string; description?: string; isOverallObjective?: boolean; strategicObjectiveReference?: string }) =>
    apiClient.post<{ data: { id: number } }>(`/api/projects/${projectId}/objectives`, input),
  update: (id: number, input: { title: string; description?: string; strategicObjectiveReference?: string }) =>
    apiClient.put<{ data: ProjectObjective }>(`/api/project-objectives/${id}`, input),
  deactivate: (id: number) => apiClient.delete<{ data: unknown }>(`/api/project-objectives/${id}`),
};

export const projectLogframeApi = {
  listOutcomes: (projectId: number) => apiClient.get<{ data: ProjectOutcome[] }>(`/api/projects/${projectId}/outcomes`),
  createOutcome: (projectId: number, input: { statement: string; description?: string }) =>
    apiClient.post<{ data: { id: number; outcomeCode: string } }>(`/api/projects/${projectId}/outcomes`, input),
  updateOutcome: (id: number, input: { statement: string; description?: string }) => apiClient.put<{ data: ProjectOutcome }>(`/api/project-outcomes/${id}`, input),
  deactivateOutcome: (id: number) => apiClient.delete<{ data: unknown }>(`/api/project-outcomes/${id}`),

  listOutputs: (outcomeId: number) => apiClient.get<{ data: ProjectOutput[] }>(`/api/project-outcomes/${outcomeId}/outputs`),
  createOutput: (outcomeId: number, input: { statement: string; description?: string }) =>
    apiClient.post<{ data: { id: number; outputCode: string } }>(`/api/project-outcomes/${outcomeId}/outputs`, input),
  updateOutput: (id: number, input: { statement: string; description?: string }) => apiClient.put<{ data: ProjectOutput }>(`/api/project-outputs/${id}`, input),
  deactivateOutput: (id: number) => apiClient.delete<{ data: unknown }>(`/api/project-outputs/${id}`),

  listIndicators: (outputId: number) => apiClient.get<{ data: ProjectIndicator[] }>(`/api/project-outputs/${outputId}/indicators`),
  listIndicatorsForProject: (projectId: number) => apiClient.get<{ data: ProjectIndicator[] }>(`/api/projects/${projectId}/indicators`),
  createIndicator: (outputId: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/project-outputs/${outputId}/indicators`, input),
  updateIndicator: (id: number, input: Record<string, unknown>) => apiClient.put<{ data: ProjectIndicator }>(`/api/project-indicators/${id}`, input),
  updateIndicatorActual: (id: number, input: { actualValue?: string | null; trackingStatus?: string | null; dateOfVerification?: string | null }) =>
    apiClient.patch<{ data: unknown }>(`/api/project-indicators/${id}/actual`, input),
  deactivateIndicator: (id: number) => apiClient.delete<{ data: unknown }>(`/api/project-indicators/${id}`),
};

export const projectActivitiesApi = {
  listForProject: (projectId: number) => apiClient.get<{ data: ProjectActivity[] }>(`/api/projects/${projectId}/activities`),
  listForOutput: (outputId: number) => apiClient.get<{ data: ProjectActivity[] }>(`/api/project-outputs/${outputId}/activities`),
  createForOutput: (outputId: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/project-outputs/${outputId}/activities`, input),
  update: (id: number, input: Record<string, unknown>) => apiClient.put<{ data: ProjectActivity }>(`/api/project-activities/${id}`, input),
  deactivate: (id: number) => apiClient.delete<{ data: unknown }>(`/api/project-activities/${id}`),
};

export const projectRisksApi = {
  listForProject: (projectId: number) => apiClient.get<{ data: ProjectRisk[] }>(`/api/projects/${projectId}/risks`),
  create: (projectId: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number; overall_rating: string } }>(`/api/projects/${projectId}/risks`, input),
  update: (id: number, input: Record<string, unknown>) => apiClient.put<{ data: ProjectRisk }>(`/api/project-risks/${id}`, input),
};
